module.exports = __webpack_public_path__ + "img/2019qinglongxia-4.f28d5e88.jpg";